import styled from 'styled-components';
import { BLACK, BLUE_RIBBON_300, GRAYSCALE_500, NEUTRAL_100, PALE_PURPLE, WHITE } from '@styles/colors';
import { INTER } from '@styles/fonts';
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 16px 12px 64px 12px;
  overflow-y: auto;
`;

export const DepositCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${PALE_PURPLE};
  border-radius: 16px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 12px 8px 12px;
  border-bottom: 1px solid #E5E5E5;
  gap: 16px;
`;

export const CryptoIcon = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 100px;
  border: 1px solid #E5E5E5;
  padding: 8px;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CryptoName = styled.span`
  color: ${BLACK};
  font-family: ${INTER.bold};
`;

export const NetworkName = styled.span`
  color: ${BLUE_RIBBON_300};
  font-family: ${INTER.regular};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  gap: 16px;
`;

export const CardFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  border-top: 1px solid #E5E5E5;
`;

export const FooterText = styled.span`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.regular};
  text-align: center;
`;

export const QRCodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 12px;
`;

export const ShareButtonContainer = styled.div`
  margin: 24px 0 16px 0;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: ${WHITE};
`;

export const CardContentWrapper = styled.div`
  color: ${GRAYSCALE_500};
`;

export const ExchangeRateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  position: relative;
  padding: 4px 12px;
`;

export const CurrencyPair = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CurrencyLabel = styled.span`
  font-family: ${INTER.light};
  font-weight: 300;
  font-size: 13px;
`;

export const CurrencyValue = styled.span`
  font-family: ${INTER.medium};
  font-weight: 500;
  font-size: 13px;
`;

export const ExchangeIconWrapper = styled.div`
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${WHITE};
  border-radius: 100%;
  position: absolute;
  left: 46%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
`;

export const ValidityRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  padding: 6px 8px;
`;

export const ValidityInfo = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  gap: 4px;
`;

export const ValidityLabel = styled.span`
  font-family: ${INTER.semiBold};
  font-weight: 600;
  font-size: 12px;
`;

export const FixedQuoteButtonWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const AddressesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
`;
